<div class="row">
  <div class="col-12">
    <mat-card class="w-100">
      <mat-card-content>
        <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
          <mat-card-title class="m-0">Master Batches</mat-card-title>
          <div class="d-flex align-items-center gap-2">
            <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
              <mat-label>Search Batches</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="Search by batch number, prefix..." />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            <button mat-raised-button color="primary" class="btn-generate-batch" (click)="openCreateBatchDialog()">
              <mat-icon class="me-1">add</mat-icon>
              Generate Batch
            </button>
          </div>
        </div>

        <!-- Spinner -->
        <div *ngIf="spinner" class="d-flex justify-content-center py-5">
          <mat-spinner diameter="40"></mat-spinner>
        </div>

        <!-- Table -->
        <div class="table-responsive" *ngIf="!spinner">
          <table mat-table [dataSource]="dataSource" matSort class="text-nowrap w-100">
            <!-- Batch Number -->
            <ng-container matColumnDef="batchNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Batch Number</th>
              <td mat-cell *matCellDef="let element">
                <span class="batch-number">{{ element.batchNumber }}</span>
              </td>
            </ng-container>


            <!-- Range -->
            <ng-container matColumnDef="range">
              <th mat-header-cell *matHeaderCellDef class="text-center">Seq Range</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <span class="range-badge">
                  {{ element.startSeq }} - {{ element.endSeq }}
                </span>
              </td>
            </ng-container>

            <!-- Total Count -->
            <ng-container matColumnDef="totalCount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Total</th>
              <td mat-cell *matCellDef="let element" class="text-center fw-bold text-dark">
                {{ element.totalCount }}
              </td>
            </ng-container>

            <!-- Used Count -->
            <ng-container matColumnDef="usedCount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center">Used</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <span class="badge badge-neutral">{{ element.usedCount }}</span>
              </td>
            </ng-container>

            <!-- Remaining Count -->
            <ng-container matColumnDef="remaining">
              <th mat-header-cell *matHeaderCellDef class="text-center">Available</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <span
                  class="badge"
                  [ngClass]="(element.totalCount - element.usedCount > 0) ? 'badge-success' : 'badge-danger'">
                  {{ element.totalCount - element.usedCount }}
                </span>
              </td>
            </ng-container>

            <!-- Created At -->
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
              <td mat-cell *matCellDef="let element" class="text-muted">
                {{ element.createdAt | date : "dd/MM/yyyy hh:mm a" }}
              </td>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>
              <td mat-cell *matCellDef="let element" class="text-center">
                <div class="d-inline-flex align-items-center justify-content-center gap-2">
                  <!-- Generating status badge -->
                  <span *ngIf="element.status === 'generating'" class="badge bg-warning text-dark py-2 px-2 d-inline-flex align-items-center gap-1">
                    <mat-spinner diameter="12" class="d-inline-block"></mat-spinner>
                    <span>Generating {{ element.progress || 0 }}%</span>
                  </span>

                  <button
                    *ngIf="element.status !== 'generating'"
                    mat-stroked-button
                    color="primary"
                    class="btn-export-excel"
                    [disabled]="exportingBatchId === element._id"
                    (click)="exportExcel(element)">
                    <span *ngIf="exportingBatchId !== element._id" class="export-content">
                      <mat-icon class="export-icon">file_download</mat-icon>
                      <span>Download</span>
                    </span>
                    <mat-spinner
                      *ngIf="exportingBatchId === element._id"
                      diameter="16"
                      class="d-inline-block">
                    </mat-spinner>
                  </button>

                  <!-- Delete Button: Only enabled if batch is unused -->
                  <button
                    mat-icon-button
                    color="warn"
                    class="btn-delete-action"
                    [disabled]="element.usedCount > 0 || element.status === 'generating'"
                    (click)="deleteBatch(element)"
                    [matTooltip]="element.usedCount > 0 ? 'Cannot delete: Batch is in use' : (element.status === 'generating' ? 'Cannot delete while generating' : 'Delete Batch')">
                    <mat-icon class="delete-icon">delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            <!-- No data row -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell text-center py-4" [attr.colspan]="displayedColumns.length">
                No Master Batches found. Click <strong>Generate Batch</strong> to create your first batch pool.
              </td>
            </tr>
          </table>

          <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
